import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import PageLoader from "../components/loaders/PageLoader";

const CLIENT_ID = import.meta.env.VITE_SHOPIFY_API_KEY;
const SCOPES = [
  "read_customers",
  "read_customer_merge",
  "read_discounts",
  "read_marketing_events",
  "read_price_rules",
  "read_pixels",
  "read_inventory",
  "read_products",
  "read_product_listings",
  "read_orders",
  "read_order_edits",
  "read_all_orders",
  "read_files",
  "read_themes",
  "read_draft_orders",
  "read_returns",
  "read_companies",
  "read_cart_transforms",
  "read_assigned_fulfillment_orders",
  "read_merchant_managed_fulfillment_orders",
  "read_third_party_fulfillment_orders",
  "read_gift_cards",
  "read_fulfillments",
  "read_payment_terms",
  "read_shopify_payments_payouts",
  "customer_read_markets",
  "customer_read_orders"
].join(",");

const REDIRECT_URI = import.meta.env.VITE_SHOPIFY_REDIRECT_URI;

export const OAuthRedirect = () => {
  const [searchParams] = useSearchParams();
  const shop = searchParams.get("shop");


  useEffect(() => {
  try {

    if (!shop) {
        console.warn("Missing shop param");
        return;
      }


    const state = crypto.randomUUID();
    const oauthUrl = `https://${shop}/admin/oauth/authorize` +
      `?client_id=${CLIENT_ID}` +
      `&scope=${SCOPES}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&state=${state}`;

    window.location.href = oauthUrl;
    } catch (err) {
      console.error("OAuth redirect error:", err);
    }
  }, [shop]);


  return <PageLoader message="Redirecting to Shopify for app installation..." />;
};
